import React, { useState } from "react";
import * as Components from "us.common/components";
import { COLUMNS } from "us.collection.admin/components/CreditorApproval/Constants";
import { useTranslation } from "react-i18next";
import { getCreditorApprovalInfoTableColumns } from "us.collection.admin/components/CreditorApproval/Functions";

const { $TableTree } = Components;

/**
 * @description - Creditor Approval Info Table  component to show all the creditor approvals pending list
 * @link Design Document - https://unicorn-solutions.atlassian.net/wiki/spaces/USU/pages/4198006795/CreditorApproval+-+UI+Implementation+-+Fair
 * @author Keshan Nimnaka <keshana@unicorn-solutions.com>
 * @since 22/09/2025
 */
export type CreditorApprovalInfoTableProps = {
  tableData: Array<any>;
  onCallAction: (record: any) => void;
};

const CreditorApprovalInfoTable: React.FC<CreditorApprovalInfoTableProps> = (
  props
) => {
  const { onCallAction, tableData } = props;
  const { t } = useTranslation();

  const [selectedRowKey, setSelectedRowKey] = useState<string | null>(null);

  return (
    <$TableTree
      rowKey={(record: any) => record.requestId}
      data={tableData}
      size="small"
      filterOnType
      bordered
      className="mt-3"
      onSort={(sortData, dataSource) => sortData(dataSource)}
      onFilter={(searchData, dataSource) => searchData(dataSource)}
      pagination={{ defaultPageSize: 20 }}
      scroll={{ x: 1300, y: "calc(100vh - 195px)" }}
      style={{ marginLeft: 0, paddingLeft: 0 }}
      rowClassName={(record) =>
        record.requestId === selectedRowKey ? "selected-row" : ""
      }
      onRow={(record, _rowIndex) => {
        return {
          onDoubleClick: () => {
            setSelectedRowKey(record.requestId);
            onCallAction && onCallAction(record);
          },
        };
      }}
      columns={getCreditorApprovalInfoTableColumns(
        COLUMNS,
        onCallAction,
        setSelectedRowKey
      )}
      data-testid="creditor-approval-info-table"
      locale={{
        filterConfirm: t("COMMON.OK"),
        filterReset: t("COMMON.RESET"),
      }}
      resetOnSourceChange={true}
      firstColSkipFilterProps={-1}
    />
  );
};

export default CreditorApprovalInfoTable;
